import linkFragment from './link'

export const fields = `
  _key,
  _type,
  style,
  listItem,
  markDefs[] {
    _key,
    _type,
    _type == "link" => {
      ${linkFragment.fields}
    }
  },
  children[] {
    _key,
    _type,
    marks[],
    text
  }
  `

export const fragment = (name = 'richText') => `${name}[]{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
